(function() {
    'use strict';

    angular
        .module('telestatApp')
        .factory('ComplainOnSmsSearch', ComplainOnSmsSearch);

    ComplainOnSmsSearch.$inject = ['$resource'];

    function ComplainOnSmsSearch($resource) {
        var resourceUrl =  'api/_search/complain-on-sms/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
